import router from '@/router';

const state = {
	kstq7ueu_dbid: {
		// 试验
		experiment: 1,
		// 试验注册
		chictr: 5,
		// 申办方
		sponsor: 2,
		// 研究中心
		research_center: 3,
		// 研究者
		researcher: 4,
		// 供应商-合同研究者(CRo)
		cro: 6,
		// 供应商-第三方实验室
		lab: 7,
		// 医学指南
		medicalguide: 8,
		// 临床现场管理组织-SMO
		smo: 9,
		// 指导原则
		guideprinciple: 10,
		// 美国临床
		linchuangus: 11,
		// 韩国临床
		linchuangkr: 12,
		// 日本临床
        linchuangjp: 13,
		// 研究者风险信息
        researcher_risk: 14,
        // 澳洲临床
        linchuangau: 15,
        // 其他供应商
        supplier: 16,
	},
	experiment_from: 'CTR',
	gys_from: 'CRO',
	other_from: '医学指南',
	researcher_from: '',
}
const getters = {
	kstq7ueu_dbid(state) {
		return state.kstq7ueu_dbid[router.app.$route.path.match(/\/(\w+)/)?.[1] ?? 'research_center'];
	}
}
const mutations = {
}
const actions = {
	async experiment_from({ commit }, res) {
		commit('experiment_from', res);
	},
	async gys_from({ commit }, res) {
		commit('gys_from', res);
	},
	async other_from({ commit }, res) {
		commit('other_from', res);
	},
	async researcher_from({ commit }, res) {
		commit('researcher_from', res);
	},
}

export default {
	state,
	getters,
	mutations,
	actions
}
